import Button from '../Button.jsx'
import useAllApplications from '../../utils/useAllApplicants.js';
import {Alert,Table, Tag} from "antd";
import {deleteDoc, doc} from "firebase/firestore";
import {db} from "@/firebaseConfig.js";
import Header from "@components/Header.jsx";
import {useState} from "react";

import AppModal from "@components/AdminPanel/AppModal.jsx";
import {useAuth} from "@/utils/auth.jsx";
import useAllUsers from "@/utils/fetchAllUsers.js";

const Apps = () => {

    const { applications, refetchApplications } = useAllApplications();
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);

    const {user} = useAuth();
    const {users} = useAllUsers();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingApp, setEditingApp] = useState(null);

    const openCreateModal = () => {
        setEditingApp(null);
        setIsModalOpen(true);
    };

    const openEditModal = (app) => {
        setEditingApp(app);
        setIsModalOpen(true);
    };



    const columns = [
        {
            title: 'Name',
            dataIndex: 'appName',
            render: (text) => <a>{text}</a>,
            key: 'appName'
        },
        {
            title: 'Owner',
            dataIndex: 'ownerEmail',
            render: (text) => <a>{text}</a>,
            key: 'appName'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (_, { status }) => {
                let color;
                switch (status.toLowerCase()) {
                    case 'moderation':
                        color = 'orange';
                        break;
                    case 'finished':
                        color = 'green';
                        break;
                    case 'on process':
                        color = 'blue';
                        break;
                    case 'rejected':
                        color = 'volcano';
                        break;
                    default:
                        color = 'gray';
                }
                return <Tag color={color}>{status.toUpperCase()}</Tag>;
            }


        },
        {
            title: 'Created at',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (timestamp) => {
                if (!timestamp) return 'N/A';

                const dateObj = timestamp.toDate ? timestamp.toDate() : new Date(timestamp.seconds * 1000);

                return dateObj.toLocaleString(); // format as you like
            },
        },
        {
            title: 'Edit',
            key: 'x',
            render: (_, record) => (
                <a onClick={() => openEditModal(record)}>
                    Edit
                </a>
            ),
        },
        {
            title: 'Delete',
            dataIndex: '',
            key: 'delete',
            render: (_, record) => (
                <a
                    style={{ color: "red" }}
                    onClick={async () => {
                        try {
                            await deleteDoc(doc(db, "apps", record.id));
                            setSuccess(true);
                            await refetchApplications();
                        } catch (error) {
                            console.error("Failed to delete app:", error);
                            setError(true);
                        }
                    }}
                >
                    Delete
                </a>
            ),

        }


    ];


    return (
        <div className="app-page">
            {success && (
                <Alert
                    message="Success!"
                    type="success"
                    showIcon
                    closable
                    onClose={() => setSuccess(false)}
                />
            )}

            {error && (
                <Alert
                    message="Failed!"
                    type="error"
                    showIcon
                    closable
                    onClose={() => setError(false)}
                />
            )}
            <div className="wrapper">
              <h2 >Apps </h2>
                <div className={`page page-app` }>
                    <Button onClick={openCreateModal} title={`Create App`} />
                    <Table   columns={columns} dataSource={applications} />
                </div>
            </div>
            <AppModal
                open={isModalOpen}
                app={editingApp}
                user={user}
                users={users}
                onCancel={() => setIsModalOpen(false)}
                onSuccess={() => {
                    setIsModalOpen(false);
                    refetchApplications();
                }}
                setSuccess={setSuccess}
                setError={setError}
            />
        </div>

    )

}

export default Apps;